import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Header } from './components/Header';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { AttractionsGrid } from './components/AttractionsGrid';
import { BirthdayParties } from './components/BirthdayParties';
import { GroupEvents } from './components/GroupEvents';
import { DiningSection } from './components/DiningSection';
import { CountdownSignup } from './components/CountdownSignup';
import { LocationInfo } from './components/LocationInfo';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Header data-id="element-2" />
      <Navigation data-id="element-3" />
      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <AttractionsGrid data-id="element-6" />
        <BirthdayParties data-id="element-7" />
        <GroupEvents data-id="element-8" />
        <DiningSection data-id="element-9" />
        <CountdownSignup data-id="element-10" />
        <LocationInfo data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}